module.exports = __webpack_public_path__ + "officialStatic/img/product-sjxt.63a530c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/product-sjxt.png
// module id = 7Oa7
// module chunks = 0